<script>

    import { TicketStore } from '../stores'

    import DateMethods from '../$methods/date.methods'
    import EnumMethods from '../$methods/enum.methods'

    import Button from '../$components/button.svelte'
    import Value from '../$components/value.svelte'

</script>

{#if $TicketStore}
    <div class="columns">
        <div class="column">
            <Button on:click={() => TicketStore.modalUpdate($TicketStore)} icon="edit" text="Actualizar" color="primary" size="small" />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <Value label="Estatus" value={ EnumMethods.get($TicketStore.status) } />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <Value label="Asunto" value={ $TicketStore.subject } />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <Value label="Mensaje" value={ $TicketStore.message } />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <Value label="Fecha de registro" value={ DateMethods.dateTimeLarge($TicketStore.created) } />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <Value label="Factura" value={$TicketStore.invoiceDocument? 'Descargar' : 'Sin información'} link={ $TicketStore.invoiceDocument } />
        </div>
        <div class="column">
            <Button on:click={() => TicketStore.modalOpen('TicketDocument', $TicketStore)} icon="file-upload" />
        </div>
    </div>
    {#if $TicketStore.history && $TicketStore.history.length}
        <hr>
        <div class="subtitle is-5">Historial</div>
        {#each $TicketStore.history as item}
            <div class="columns">
                <div class="column">
                    <div class="items end">
                        <small>{ DateMethods.dateTimeLarge(item.created) }</small>
                    </div>
                    <Value label={ EnumMethods.get(item.from) } value={ item.response } />
                </div>
            </div>
        {/each}
    {/if}
{/if}